
import showToastify from '../utils/toastify';
import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css"
import axios from 'axios'
import { find } from 'utils/dom'
const form = () => {
document.addEventListener('DOMContentLoaded', function() {
  const contatoFormSubmit = document.querySelector('#enter-in-contact');
  const btnSubmit = document.querySelector("#enter-in-contact button[type=submit]");


  if(!contatoFormSubmit)return
  document.getElementById('email').addEventListener('input', function(e) {
    let value = e.target.value;
    if (value.length > 0) {
      value = value.charAt(0).toLowerCase() + value.slice(1);
    }
    e.target.value = value;
  });

  document.getElementById('telefone').addEventListener('input', function(e) {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 0) {
      value = '(' + value;
    }
    if (value.length > 3) {
      value = value.slice(0, 3) + ') ' + value.slice(3);
    }
    if (value.length > 10) {
      value = value.slice(0, 10) + ' - ' + value.slice(10);
    }
    e.target.value = value;
  });

  if (contatoFormSubmit) {
    contatoFormSubmit.addEventListener('submit', function(event) {
      event.preventDefault();

      disabledBtn(btnSubmit);

      const form_data = {
        nome: document.querySelector('#enter-in-contact input[name=nome]').value,
        email: document.querySelector('#enter-in-contact input[name=email]').value,
        telefone: document.querySelector('#enter-in-contact input[name=telefone]').value,
        cidade: document.querySelector('#enter-in-contact input[name=cidade]').value,
        estado: document.querySelector('#enter-in-contact input[name=estado]').value,
        mensagem: document.querySelector('#enter-in-contact textarea[name=mensagem]').value
      };

      const url = "/fale-conosco/";
      axios.post(url, form_data)
        .then((response) => showMessage(response))
        .catch((response) => showMessage(response));

      function showMessage(response) {
  const message = response.data ? response.data.message : response.message;

  const toast = document.createElement("div");
  toast.innerText = message;
  toast.style.position = "fixed";
  toast.style.top = "50%";
  toast.style.left = "50%";
  toast.style.transform = "translate(-50%, -50%)";
  toast.style.background = "#4BB543";
  toast.style.color = "#fff";
  toast.style.padding = "1rem 2rem";
  toast.style.borderRadius = "8px";
  toast.style.fontSize = "16px";
  toast.style.zIndex = "9999";
  toast.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.3)";
  toast.style.opacity = "1";
  toast.style.transition = "opacity 0.3s ease";

  document.body.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = "0";
    setTimeout(() => toast.remove(), 300); // remove após fade
  }, 4000);

  contatoFormSubmit.reset();
  setTimeout(() => enabledBtn(btnSubmit), 1000);
}



      function disabledBtn(btn) {
        btn.disabled = true;
        btn.classList.add("disabled");
      }

      function enabledBtn(btn) {
        btn.disabled = false;
        btn.classList.remove("disabled");
      }
    });
  }



});
}

export default form;